import SignupWorker from "../components/auth/sign-up-worker";
// import IsAdmin from "../../components/admin/isAdmin";
// import GuestView from "../components/layout/guest";
// const appst = () => {
//   return (
//     <GuestView>
//       <SignupWorker />
//     </GuestView>
//   );
// };
// export default appst;
export default SignupWorker;
